import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @ actions
import { initCheckFilter, setCheckFilter } from 'actions/filters'
// @ components
import { OKCheckbox } from 'commonsComponents/OKCheckbox';

class CheckFilter extends PureComponent {

    componentDidMount() {
        const {
            filtersId,
            filterId,
            filterType,
            immFilter,
            initialValue,
            label,
            value,
            initCheckFilter,
            isTaggable
        } = this.props;
        !immFilter && initCheckFilter(filtersId, filterId, initialValue, filterType, value, label, isTaggable);
    }

    handleCheckboxChange = () => {
        const {
            immFilter,
            filtersId,
            filterId,
            setCheckFilter
        } = this.props;
        const active = immFilter.get('active');
        setCheckFilter(filtersId, filterId, !active);
    }

    render() {
        const {
            immFilter,
            filterId,
            disabled,
            label,
            extraClass,
            isRelative,
            colorLegend
        } = this.props;

        if (immFilter) {
            const active = immFilter.get('active');

            return (
                <OKCheckbox
                    idName={filterId}
                    onChange={this.handleCheckboxChange}
                    value={active}
                    disabled={disabled}
                    label={label}
                    extraClass={extraClass}
                    isRelative={isRelative}
                    colorLegend={colorLegend}
                />
            );
        } else {
            return null
        }
    }
}

CheckFilter.defaultProps = {
    initialValue: true,
    filterType: 'checkFilter',
    isTaggable: true
}

CheckFilter.propTypes = {
    colorLegend: PropTypes.string,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    errorState: PropTypes.bool,
    extraClass: PropTypes.string,
    filterId: PropTypes.string.isRequired,
    filterType: PropTypes.string,
    filtersId: PropTypes.string,
    hasLegend: PropTypes.bool,
    immFilter: PropTypes.object,
    initCheckFilter: PropTypes.func,
    initialValue: PropTypes.bool.isRequired,
    instructionsMessage: PropTypes.string,
    isRelative: PropTypes.bool,
    isTaggable: PropTypes.bool,
    label: PropTypes.any,
    onChange: PropTypes.func,
    setCheckFilter: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.array,PropTypes.string])
};

export default connect(
    null,
    {
        initCheckFilter,
        setCheckFilter
    }
)(CheckFilter);